<svg xmlns="http://www.w3.org/2000/svg" [attr.viewBox]="viewBox" class="mw">
  <circle
    class="track"
    [attr.cx]="radius"
    [attr.cy]="radius"
    [attr.r]="radius - strokeWidth/2"
    [attr.stroke-width]="strokeWidth"
  />
  
  <circle
    class="filled"
    [attr.cx]="radius"
    [attr.cy]="radius"
    [attr.r]="radius - strokeWidth/2"
    [attr.stroke-width]="strokeWidth"
    [style.stroke-dasharray]="circumference"
    [style.stroke-dashoffset]="calculateDashOffset(percent)"
    [attr.transform]="'rotate(-90 ' + radius + ' ' + radius + ')'"
    [style.stroke]="outerStrokeColor"
  />
  
  <text
    [attr.x]="radius"
    [attr.y]="radius - textOffset"
    text-anchor="middle"
    [style.fill]="titleColor"
    [style.font-size]="titleFontSize"
    [style.font-weight]="titleFontWeight"
  >
    {{ percent }}%
  </text>

  <text
    [attr.x]="radius"
    [attr.y]="radius + textOffset"
    text-anchor="middle"
    [style.fill]="subtitleColor"
    [style.font-size]="subtitleFontSize"
  >
    {{ subtitle }}
  </text>
</svg>
